export default "__VITE_ASSET__DBytdFsA__"